import React, { FunctionComponent } from 'react';
import { MusicList } from '../../../components/music-list/music-list';
import { useStore } from '../../../helpers/use-store';
import { useTranslation } from 'react-i18next';

interface Props {
  onSelect: (musicUrl: string, name: string) => void;
}

const LibraryAudio: FunctionComponent<Props> = ({ onSelect }) => {
  const { t } = useTranslation();
  const {
    dataStore: { musicStore },
  } = useStore();

  const onMusicSelect = (musicId: string | null) => {
    if (!musicId) {
      return;
    }

    const music = musicStore.items.find((music) => music._id === musicId);

    if (!music) {
      return;
    }

    onSelect(music.audioUrl, music.name);
  };

  return (
    <div className="library-audio-container">
      <MusicList
        gridColumns={2}
        backgroundMusicVolume={0.1}
        musics={musicStore.items}
        onMusicSelect={onMusicSelect}
        showUpdateButton={false}
        updateButtonText={t('common.update')}
      />
    </div>
  );
};

export default LibraryAudio;
